import useConfig from 'hooks/useConfig';
import { values } from 'lodash-es';

const useStructuredData = () => {
  const config = useConfig();
  if (!config.general) {
    return null;
  }
  return {
    '@context': 'https://schema.org/',
    '@type': 'WebSite',
    name: config.general.name,
    url: window.location.origin,
    image: config.general.logo,
    description: config.web.pageMeta?.description,
    alternateName: config.general.alternateName,
    sameAs: values(config.general.socialMedia) || [],
    copyrightHolder: 'Omnicart',
    potentialAction: {
      '@type': 'SearchAction',
      target: {
        '@type': 'EntryPoint',
        urlTemplate: `${window.location.origin}/pwa/search/{search_term_string}`,
      },
      'query-input': 'required name=search_term_string',
    },
    isFamilyFriendly: true,
    about: {
      '@type': 'Organization',
      email: config.general.email,
      name: config.general.name,
      telephone: config.general.phone,
      image: config.general.logo,
      logo: config.general.logo,
      keywords: 'Order Online, Food Delivery, Takeout, Restaurant Delivery',
      location: {
        '@type': 'Place',
        geo: {
          '@type': 'GeoCoordinates',
          latitude: config.general.defaultLat,
          longitude: config.general.defaultLong,
        },
      },
    },
  };
};

export default useStructuredData;
